import { ShipService } from './ship-service'

let shipService = new ShipService();

export { shipService }